// app/javascript/projects/components/ProjectsDisplay.jsx

import React, {useState, useCallback} from 'react';

import FileDropZone from './FileDropZone'
import FileErrorModal from './FileErrorModal'
import NewTranscriptContainer from './NewTranscriptContainer'
import { useProjectWithErrorHandling } from 'hooks/projects/useProjectWithErrorHandling';
import { useUploadFiles } from 'hooks/mutations/useUploadFiles';

function DragDropTranscriptContainer({projectID, onboardingState, history}) {
  // Check if project exists and handle 404
  const { NotFoundComponent } = useProjectWithErrorHandling(projectID);
  const [isHover, setIsHover] = useState(false);
  const uploadFilesMutation = useUploadFiles();

  const onDrop = useCallback((acceptedFiles) => {
    setIsHover(false);
    uploadFilesMutation.mutate({ projectId: projectID, files: acceptedFiles });
  }, [projectID, uploadFilesMutation]);
  
  const clearError = useCallback(() => {
    uploadFilesMutation.reset();
  }, [uploadFilesMutation]);

  const isHovering = useCallback((isHover) => {
    setIsHover(isHover);
  }, []);

  if (NotFoundComponent) {
    return <NotFoundComponent />;
  }

  return (
    <div style={{height:"100%"}}>
        <FileDropZone
          onDrop={onDrop}
          isHovering={isHovering}
          >
          {projectID &&
            <NewTranscriptContainer
              projectID={projectID}
              isHover={isHover}
              onboardingState={onboardingState}
              history={history}
            />
          }
        </FileDropZone>
        <FileErrorModal
          type={uploadFilesMutation.error?.name}
          onClear={clearError}
        />
    </div>
  );
}

export default DragDropTranscriptContainer;